import { QueryClient } from "@tanstack/react-query"
import { isAxiosError } from "axios"

/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
const retry = (failureCount: number, error: any) =>
  // Fail a maximum of 3 times total (including the last extra attempt)
  failureCount < 2 &&
  // Don't retry on errors that are guaranteed to fail again
  !(isAxiosError(error) && [400, 401, 403, 404, 405, 413, 414, 429].includes(error.response?.status ?? 0))

// Retry with exponential backoff 1s, 3s, 9s
const retryDelay = (failureCount: number) => 1000 * 3 ** failureCount

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry,
      retryDelay,
    },
    mutations: {
      retry,
      retryDelay,
    },
  },
})

declare global {
  interface Window {
    queryClient: QueryClient
  }
}

// Expose the QueryClient to e2e tests for tests involving cache invalidations
if (!import.meta.env.PROD) {
  window.queryClient = queryClient
}
